jQuery(document).ready(function() {
    if (jQuery('.joy-video-autoplay .et_pb_video_box').length !== 0) {

        jQuery('.joy-video-autoplay .et_pb_slide_video').find('video').prop('muted', true);
        jQuery(".joy-video-autoplay .et_pb_slide_video").find('video').attr('playsInline', '');
        jQuery(".joy-video-autoplay .et_pb_slide_video").find('video').attr('loop', 'loop');

        jQuery(".joy-video-autoplay .et_pb_slide_video").each(function() {
            jQuery(this).find('video').get(0).play();
        });

        jQuery('.joy-video-autoplay .et_pb_slide_video').find('video').removeAttr('controls');

    }
});